import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Icon from './Icon';

const Navigation: React.FC = () => {
  const location = useLocation();
  const { username, isSuperuser, logout } = useAuth();

  const navItems = [
    { path: '/', label: 'Meal Plan', icon: 'home' },
    { path: '/hungry', label: 'Hungry', icon: 'flame' },
    { path: '/my-recipes', label: 'Recipes', icon: 'book' },
    { path: '/pantry', label: 'Pantry', icon: 'basket' },
    { path: '/shopping', label: 'Shopping', icon: 'cart' },
    { path: '/settings', label: 'Settings', icon: 'gear' },
    ...(isSuperuser ? [{ path: '/household-admin', label: 'Households', icon: 'box' }] : []),
  ];

  return (
    <>
      {/* Compact header shown only on small screens; the sidebar's own
          header/footer are hidden there so this replaces them. */}
      <header className="mobile-topbar">
        <span className="mobile-topbar-logo">
          <Icon name="pan" className="icon" /> RecipeEngine
        </span>
        <button className="mobile-logout-btn" onClick={() => logout()} aria-label="Log out">
          <span aria-hidden="true">⎋</span>
        </button>
      </header>

      <nav className="navigation">
        <div className="nav-header">
          <h1 className="nav-logo">
            <Icon name="pan" className="icon" /> RecipeEngine
          </h1>
          <p className="nav-tagline">AI-Powered Kitchen Automation</p>
        </div>
        <ul className="nav-list">
          {navItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              >
                <Icon name={item.icon} className="icon nav-icon" />
                <span className="nav-label">{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
        <div className="nav-footer">
          <span className="nav-username">{username}</span>
          <button className="btn-secondary" onClick={() => logout()}>
            Log out
          </button>
        </div>
      </nav>
    </>
  );
};

export default Navigation;
